/* bundle-steps.js - Annah Stretton Bundle Builder */
(function () {
  'use strict';

  var data = window.BundleData;
  if (!data) return;

  /* ---- State ---- */
  var currentStep = 1;
  var selections  = {};   /* { stepNum: { variantId, price, name, img } } */
  var greetingSelection = null;
  var giftMessage = '';

  /* ---- Money formatting ---- */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var noDecimals = String(Math.round(cents / 100));
    return (data.moneyFormat || '${{amount}}')
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', amount);
  }

  /* ---- Scroll helpers ---- */
  function scrollToSteps() {
    var step = document.querySelector('.bundle-step:not([hidden])');
    if (!step) return;
    var top = window.pageYOffset + step.getBoundingClientRect().top - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function scrollToSidebar() {
    var slots = document.getElementById('bundle-summary-slots');
    if (!slots) return;
    var top = window.pageYOffset + slots.getBoundingClientRect().top - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* ---- Progress ---- */
  function updateProgress() {
    var dots = document.querySelectorAll('.bundle-progress-step');
    dots.forEach(function (dot) {
      var n = parseInt(dot.dataset.dot, 10);
      dot.classList.remove('bundle-progress-step--done', 'bundle-progress-step--current');
      if (n < currentStep)      dot.classList.add('bundle-progress-step--done');
      else if (n === currentStep) dot.classList.add('bundle-progress-step--current');
    });

    var fill = document.getElementById('bundle-progress-fill');
    var text = document.getElementById('bundle-progress-text');
    if (fill) fill.style.width = ((currentStep - 1) / data.stepCount * 100) + '%';
    if (text) text.textContent = 'Step ' + currentStep + ' of ' + data.stepCount;
  }

  /* ---- Step navigation ---- */
  function goToStep(stepKey) {
    document.querySelectorAll('.bundle-step').forEach(function (el) {
      el.hidden = true;
    });

    var target = document.querySelector('.bundle-step[data-step="' + stepKey + '"]');
    if (target) target.hidden = false;

    if (typeof stepKey === 'number') {
      currentStep = stepKey;
      /* restore next button if it was hidden */
      var nextBtn = target && target.querySelector('.js-next-btn');
      if (nextBtn) nextBtn.hidden = false;
    }

    updateProgress();
    scrollToSteps();
  }

  /* ---- Slot helpers ---- */
  function updateSlot(slotId, item) {
    var slot = document.getElementById('slot-' + slotId);
    if (!slot) return;
    slot.classList.remove('bundle-slot--empty');
    slot.innerHTML =
      '<img class="bundle-slot__img" src="' + item.img + '" alt="' + item.name + '" width="44" height="58" loading="lazy">' +
      '<div class="bundle-slot__text">' +
        '<p class="bundle-slot__name">' + item.name + '</p>' +
        '<p class="bundle-slot__price">' + formatMoney(item.price) + '</p>' +
      '</div>';
  }

  function clearSlot(slotId) {
    var slot = document.getElementById('slot-' + slotId);
    if (!slot) return;
    slot.classList.add('bundle-slot--empty');
    var label = slot.dataset.label || 'Step ' + slotId;
    slot.innerHTML =
      '<div class="bundle-slot__placeholder">+</div>' +
      '<div class="bundle-slot__text">' +
        '<p class="bundle-slot__name bundle-slot__name--empty">' + label + '</p>' +
      '</div>';
  }

  /* ---- Price calculation ---- */
  function allRequiredSelected() {
    for (var i = 1; i <= data.stepCount; i++) {
      if (!selections[i]) return false;
    }
    return true;
  }

  function calcTotals() {
    var sub = 0;
    for (var i = 1; i <= data.stepCount; i++) {
      if (selections[i]) sub += selections[i].price;
    }
    if (greetingSelection) sub += greetingSelection.price;
    var disc = allRequiredSelected() ? Math.round(sub * data.discount / 100) : 0;
    return { sub: sub, disc: disc, total: sub - disc };
  }

  function updatePriceDisplay() {
    var totals      = calcTotals();
    var subtotalEl  = document.getElementById('js-subtotal');
    var savingEl    = document.getElementById('js-saving');
    var totalEl     = document.getElementById('js-total');
    var savingRow   = document.getElementById('js-saving-row');
    var addBtn      = document.getElementById('bundle-add-btn');
    var savingsNote = document.getElementById('js-savings-note');

    if (subtotalEl) subtotalEl.innerHTML = formatMoney(totals.sub);
    if (savingEl)   savingEl.innerHTML   = '- ' + formatMoney(totals.disc);
    if (totalEl)    totalEl.innerHTML    = formatMoney(totals.total);

    var ready = allRequiredSelected();
    if (savingRow) savingRow.hidden = !ready;
    if (addBtn)    addBtn.disabled  = !ready;

    if (savingsNote) {
      if (ready && totals.disc > 0) {
        savingsNote.innerHTML = 'You save ' + formatMoney(totals.disc) + ' with this bundle!';
        savingsNote.className = 'bundle-savings-note bundle-savings-note--good';
        savingsNote.hidden = false;
      } else {
        savingsNote.hidden = true;
      }
    }
  }

  /* ---- Card selection ---- */
  function selectCard(card) {
    if (card.classList.contains('bundle-card--oos')) return;

    var stepKey = parseInt(card.dataset.step, 10);

    /* deselect others in this step */
    document.querySelectorAll('.bundle-card[data-step="' + stepKey + '"]').forEach(function (c) {
      c.classList.remove('bundle-card--selected');
      c.setAttribute('aria-pressed', 'false');
    });

    card.classList.add('bundle-card--selected');
    card.setAttribute('aria-pressed', 'true');

    /* resolve variant + price from select if multi-variant */
    var sel = card.querySelector('.bundle-card__select');
    var variantId = sel ? parseInt(sel.value, 10) : parseInt(card.dataset.variantId, 10);
    var price     = sel
      ? parseInt(sel.options[sel.selectedIndex].dataset.price, 10)
      : parseInt(card.dataset.price, 10);

    selections[stepKey] = {
      variantId: variantId,
      price:     price,
      name:      card.dataset.name,
      img:       card.dataset.img
    };

    updateSlot(stepKey, selections[stepKey]);
    updatePriceDisplay();

    /* enable next/review button for this step */
    var step    = document.querySelector('.bundle-step[data-step="' + stepKey + '"]');
    var nextBtn = step && step.querySelector('.js-next-btn');
    if (nextBtn) nextBtn.disabled = false;
  }

  function selectGreetingCard(card) {
    if (card.classList.contains('bundle-card--oos')) return;

    document.querySelectorAll('.bundle-card[data-step="greeting"]').forEach(function (c) {
      c.classList.remove('bundle-card--selected');
      c.setAttribute('aria-pressed', 'false');
    });

    card.classList.add('bundle-card--selected');
    card.setAttribute('aria-pressed', 'true');

    var sel = card.querySelector('.bundle-card__select');
    var variantId = sel ? parseInt(sel.value, 10) : parseInt(card.dataset.variantId, 10);
    var price     = sel
      ? parseInt(sel.options[sel.selectedIndex].dataset.price, 10)
      : parseInt(card.dataset.price, 10);

    greetingSelection = {
      variantId: variantId,
      price:     price,
      name:      card.dataset.name,
      img:       card.dataset.img
    };

    updateSlot('greeting', greetingSelection);
    updatePriceDisplay();

    /* show message textarea */
    var msgWrap = document.getElementById('bundle-message-wrap');
    if (msgWrap) msgWrap.hidden = false;

    /* enable "Add card & review" button */
    var addCardBtn = document.querySelector('.js-add-card-btn');
    if (addCardBtn) addCardBtn.disabled = false;
  }

  /* ---- Add to cart ---- */
  function addToCart() {
    if (!allRequiredSelected()) return;

    var addBtn = document.getElementById('bundle-add-btn');
    if (addBtn) {
      addBtn.disabled    = true;
      addBtn.textContent = 'Adding...';
    }

    var items = [];
    for (var i = 1; i <= data.stepCount; i++) {
      if (selections[i]) {
        items.push({
          id:         selections[i].variantId,
          quantity:   1,
          properties: { _bundle: data.handle }
        });
      }
    }

    if (greetingSelection) {
      items.push({
        id:         greetingSelection.variantId,
        quantity:   1,
        properties: {
          _bundle:        data.handle,
          'Gift Message': giftMessage || ''
        }
      });
    }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart/add failed');
      if (giftMessage) {
        return fetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ note: 'Gift message: ' + giftMessage })
        });
      }
    })
    .then(function () {
      showSuccess();
    })
    .catch(function (err) {
      console.error('Bundle add to cart error:', err);
      if (addBtn) {
        addBtn.disabled    = false;
        addBtn.textContent = 'Add bundle to cart';
      }
      alert('Sorry, there was a problem adding to cart. Please try again.');
    });
  }

  /* ---- Success overlay ---- */
  function showSuccess() {
    var overlay = document.getElementById('bundle-success-overlay');
    if (!overlay) return;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('bundle-success-overlay--show');
    });
  }

  function closeSuccess() {
    var overlay = document.getElementById('bundle-success-overlay');
    if (overlay) {
      overlay.classList.remove('bundle-success-overlay--show');
      setTimeout(function () { overlay.hidden = true; }, 300);
    }

    /* reset state */
    selections        = {};
    greetingSelection = null;
    giftMessage       = '';

    /* reset cards */
    document.querySelectorAll('.bundle-card').forEach(function (c) {
      c.classList.remove('bundle-card--selected');
      c.setAttribute('aria-pressed', 'false');
    });

    /* reset slots */
    for (var i = 1; i <= data.stepCount; i++) clearSlot(i);
    clearSlot('greeting');

    /* reset next buttons */
    document.querySelectorAll('.js-next-btn').forEach(function (btn) {
      btn.disabled = true;
      btn.hidden   = false;
    });

    /* reset add card button */
    var addCardBtn = document.querySelector('.js-add-card-btn');
    if (addCardBtn) addCardBtn.disabled = true;

    /* reset message */
    var msgInput = document.getElementById('bundle-gift-message');
    if (msgInput) msgInput.value = '';
    var msgCount = document.getElementById('bundle-message-count');
    if (msgCount) msgCount.textContent = '0 / 300';
    var msgWrap = document.getElementById('bundle-message-wrap');
    if (msgWrap) msgWrap.hidden = true;

    updatePriceDisplay();
    goToStep(1);
  }

  /* ---- Event wiring ---- */
  function init() {

    /* card click */
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.bundle-card');
      if (!card) return;
      if (card.dataset.step === 'greeting') selectGreetingCard(card);
      else selectCard(card);
    });

    /* card keyboard */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('.bundle-card');
      if (!card) return;
      e.preventDefault();
      if (card.dataset.step === 'greeting') selectGreetingCard(card);
      else selectCard(card);
    });

    /* variant select change — update card data + re-price if already selected */
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('.bundle-card__select');
      if (!sel) return;
      var card = sel.closest('.bundle-card');
      if (!card) return;
      var opt = sel.options[sel.selectedIndex];
      card.dataset.variantId = sel.value;
      card.dataset.price     = opt.dataset.price;
      if (card.classList.contains('bundle-card--selected')) {
        var stepKey = parseInt(card.dataset.step, 10);
        if (selections[stepKey]) {
          selections[stepKey].variantId = parseInt(sel.value, 10);
          selections[stepKey].price     = parseInt(opt.dataset.price, 10);
          updateSlot(stepKey, selections[stepKey]);
          updatePriceDisplay();
        }
        /* handle greeting step */
        if (card.dataset.step === 'greeting' && greetingSelection) {
          greetingSelection.variantId = parseInt(sel.value, 10);
          greetingSelection.price     = parseInt(opt.dataset.price, 10);
          updateSlot('greeting', greetingSelection);
          updatePriceDisplay();
        }
      }
    });

    /* next step buttons */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-next-btn');
      if (!btn) return;
      var stepNum = parseInt(btn.dataset.step, 10);
      var next    = stepNum + 1;

      if (next <= data.stepCount) {
        goToStep(next);
      } else if (data.hasGreeting) {
        document.querySelectorAll('.bundle-step').forEach(function (el) { el.hidden = true; });
        var greetStep = document.querySelector('.bundle-step[data-step="greeting"]');
        if (greetStep) greetStep.hidden = false;
        btn.hidden = true;
        scrollToSteps();
      } else {
        btn.hidden = true;
        scrollToSidebar();
      }
    });

    /* back buttons (required steps) */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-back-btn');
      if (!btn) return;
      var stepNum = parseInt(btn.dataset.step, 10);
      if (stepNum > 1) goToStep(stepNum - 1);
    });

    /* greeting back button */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.js-greeting-back-btn')) return;
      goToStep(data.stepCount);
    });

    /* skip greeting */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.js-skip-greeting-btn')) return;
      greetingSelection = null;
      giftMessage       = '';
      document.querySelectorAll('.bundle-card[data-step="greeting"]').forEach(function (c) {
        c.classList.remove('bundle-card--selected');
        c.setAttribute('aria-pressed', 'false');
      });
      clearSlot('greeting');
      var msgWrap = document.getElementById('bundle-message-wrap');
      if (msgWrap) msgWrap.hidden = true;
      document.querySelectorAll('.bundle-step').forEach(function (el) { el.hidden = true; });
      updatePriceDisplay();
      scrollToSidebar();
    });

    /* add card + review (greeting confirm) */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.js-add-card-btn')) return;
      document.querySelectorAll('.bundle-step').forEach(function (el) { el.hidden = true; });
      scrollToSidebar();
    });

    /* gift message typing */
    var msgInput = document.getElementById('bundle-gift-message');
    if (msgInput) {
      msgInput.addEventListener('input', function () {
        giftMessage = this.value;
        var counter = document.getElementById('bundle-message-count');
        if (counter) counter.textContent = this.value.length + ' / 300';
      });
    }

    /* add to cart */
    var addBtn = document.getElementById('bundle-add-btn');
    if (addBtn) addBtn.addEventListener('click', addToCart);

    /* success: view cart */
    var viewCartBtn = document.getElementById('bundle-view-cart-btn');
    if (viewCartBtn) viewCartBtn.addEventListener('click', function () {
      window.location.href = '/cart';
    });

    /* success: continue shopping */
    var continueBtn = document.getElementById('bundle-continue-btn');
    if (continueBtn) continueBtn.addEventListener('click', closeSuccess);

    /* initial price display */
    updatePriceDisplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();